import { render, staticRenderFns } from "./MonthlyExpensesProjectionReport.vue?vue&type=template&id=031c72f2&"
import script from "./MonthlyExpensesProjectionReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyExpensesProjectionReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyExpensesProjectionReport.vue?vue&type=style&index=0&id=031c72f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports